import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CartServiceService } from './cart-service.service';

enum TypesOfButtons {
  CATALOGUES = 'catalogues',
  HEADERSLINK = 'headersLink',
  SERVICES = 'services',
  SUBSCRIPTION = 'subscription',
  CATEGORIES = 'categories',
}

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  public parentComponents: any = {};
  private _domParent = document.getElementsByTagName('ION-APP')[0];

  constructor(
    private navCtrl: NavController,
    private cartSv: CartServiceService
  ) {}

  removeAllDropdowns(enteredMouse, ev, parentId?) {
    try {
      const closest = ev?.toElement?.closest('APP-DROPDOWN-LIST');
      if (enteredMouse && !closest) {
        const allDropDownList = Array.from(
          document.getElementsByTagName('APP-DROPDOWN-LIST')
        );
        for (const item of allDropDownList) {
          this._domParent.removeChild(item);
        }
      } else if (closest && parentId) {
        const otherDropdownList = Array.from(
          document.getElementsByTagName('APP-DROPDOWN-LIST')
        );

        const index = otherDropdownList.findIndex(
          (x: HTMLElement) => Number(x.dataset.parentnodeid) === parentId
        );
        const indexOfToElement = otherDropdownList.findIndex(
          (x: HTMLElement) =>
            Number(x.dataset.parentnodeid) ===
            Number(closest.dataset.parentnodeid)
        );
        if (indexOfToElement < index) {
          const itemsToRemoveFromDom = otherDropdownList.slice(
            indexOfToElement + 1
          );
          itemsToRemoveFromDom.forEach((item) => {
            this._domParent.removeChild(item);
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async goTo(item, opts?, external?, child?, search?) {
    this.removeAllDropdowns(true, undefined);
    this.cartSv.clearFilter();
    const redirectForCatalogueAndHeaderlink = async () => {
      const redirectUrl = item.type
        ? item[item.type].redirectUrl
        : item.redirectUrl;
      const type = !!redirectUrl.includes('https');
      if (type) {
        window.open(redirectUrl, '_blank');
      } else {
        await this.navCtrl.navigateForward(redirectUrl);
      }
    };

    const redirectToMarketplace = () => {
      this.cartSv.marketplaceFilers[this.parentComponents.type] = 1;
      this.cartSv.doSearch(search);
    };

    switch (this.parentComponents.type) {
      case TypesOfButtons.CATALOGUES:
        redirectForCatalogueAndHeaderlink();
        break;
      case TypesOfButtons.HEADERSLINK:
        redirectForCatalogueAndHeaderlink();
        break;
      case TypesOfButtons.SERVICES:
        redirectToMarketplace();
        break;
      case TypesOfButtons.SUBSCRIPTION:
        redirectToMarketplace();
        break;
      case TypesOfButtons.CATEGORIES:
        this.cartSv.marketplaceFilers.category = item.relation || item.id;
        this.cartSv.doSearch(search);
        break;
    }

    // let url = '/catalogue/' + opts?.catalogues?.id;
    // if (opts.type === 'headersLink') {
    //   if (child) {
    //     const btnChilds: any[] = opts.headersLink.child;
    //     const btnChild = btnChilds.find(
    //       (x) => x.name.trim().toLowerCase() === child.trim().toLowerCase()
    //     );
    //     url = btnChild.redirectUrl;
    //   } else {
    //     url = opts.headersLink.redirectUrl;
    //   }
    //   this.navCtrl.navigateForward(url);
    //   return true;
    // } else if (typeof opts === 'string') {
    //   this.navCtrl.navigateBack(opts);
    //   return true;
    // } else if (opts.type === 'categories') {
    //   if (item) {
    //     this.cartSv.marketplaceFilers.category = item.id;
    //   } else {
    //     this.cartSv.marketplaceFilers.category = opts.relation;
    //   }
    //   this.cartSv.doSearch(search);
    //   return true;
    // } else if (opts.type === 'services' || opts.type === 'subscription') {
    //   if (opts.type === 'services') {
    //     this.cartSv.marketplaceFilers.services = 1;
    //   } else {
    //     this.cartSv.marketplaceFilers.subscription = 1;
    //   }
    //   this.cartSv.doSearch(search);
    //   return true;
    // }
    // if (opts?.headersLink?.redirectUrl) {
    //   url = '/catalogue/' + opts?.catalogues?.id;
    // }
    // item = opts.type === 'services' ? undefined : item;
    // child = opts.type === 'services' ? undefined : child;
    // let query: Params;
    // if (external) {
    //   const type = !!url.includes('https');
    //   if (type) {
    //     window.open(url, '_blank');
    //   } else {
    //     this.navCtrl.navigateForward(url);
    //   }
    //   return true;
    // }
    // if (item) {
    //   query = {
    //     category: item.id,
    //   };
    //   if (child && child.target.id) {
    //     query.chCategory = child.target.id;
    //   }
    // }
    // await this.navCtrl.navigateForward(url, { queryParams: query });
    return true;
  }
}
